import { render, staticRenderFns } from "./PublicationMunMehModal.vue?vue&type=template&id=4366a6ba&"
import script from "./PublicationMunMehModal.vue?vue&type=script&lang=js&"
export * from "./PublicationMunMehModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
